import { render, staticRenderFns } from "./AppBreadcrumb.Vue?vue&type=template&id=45010efe"
import script from "./AppBreadcrumb.Vue?vue&type=script&lang=js"
export * from "./AppBreadcrumb.Vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/AppBreadcrumb.Vue
// module id = 14
// module chunks = 0